"use client";

import { HallowAnalyticsEvent, useAnalytics } from "@packages/analytics";
import { ModalTabContent } from "@packages/ui";

import { useMediaAnalyticsProps } from "../../../../hooks/useMediaAnalyticsProps";
import { SelectLengthContent } from "./SelectLengthContent.emotion";

export const SelectLengthTabContent = () => {
  const { track } = useAnalytics();
  const analyticsProps = useMediaAnalyticsProps();

  return (
    <ModalTabContent
      value={"lengthSelectMenu"}
      onVisible={() =>
        track({
          event: HallowAnalyticsEvent.ViewedMediaOptions,
          properties: {
            ...analyticsProps,
            source: "player",
          },
        })
      }
    >
      <SelectLengthContent />
    </ModalTabContent>
  );
};
